import { useEffect, useMemo, useState } from 'preact/hooks';
import useXRCheck, { XRCheckStatus } from '../../eyejack-web-core/src/ui/hooks/useXRCheck';
import { CopyToClipboardTrigger } from '../../eyejack-web-core/src/ui/components/Generics/CopyToClipboardTrigger';
import { useEJXLaunchUrl } from '../../eyejack-web-core/src/ui/hooks/useEJXLaunchUrl';
import { Spinner } from '../../eyejack-web-core/src/ui/components/Elements/Spinner';
import useUserDevice from '../../eyejack-web-core/src/ui/hooks/useUserDevice';
import Logo from '../../assets/ej-logos/White_transparent_02.png';
import { ModalOverlay } from '../../eyejack-web-core/src/ui/components/Elements/Modal/ModalOverlay';
// Removed background image imports to use solid black background

export const XRCheckOverlay = () => {
  const [showLoader, setShowLoader] = useState(true);

  const targetUrl = useEJXLaunchUrl();
  const { isMobile, iOSVersion } = useUserDevice();

  const isLegacyIOS = iOSVersion && iOSVersion < 17;

  const xrStatus = useXRCheck({ targetUrl });
  const hasError =
    ((isLegacyIOS &&
      (xrStatus === XRCheckStatus.IOS_NO_APP_CLIP ||
        xrStatus === XRCheckStatus.IOS_NOT_SAFARI ||
        xrStatus === XRCheckStatus.IOS_INCOGNITO)) ||
      xrStatus === XRCheckStatus.ANDROID_NOT_CHROME) &&
    !showLoader;
  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const encodedUrl = useMemo(() => encodeURIComponent(targetUrl), [targetUrl]);

  return (
    <>
      {xrStatus !== XRCheckStatus.OK && (
        <div className="bg-black h-full w-full flex items-center justify-center mx-auto text-white">
          {hasError && <ModalOverlay>''</ModalOverlay>}
          <div className="h-full flex w-full xmax-w-[500px] flex-col pb-10 justify-center items-center">
            <div className="basis-[60%] flex flex-col w-full px-4 pt-32 z-10">
              <img className="w-full h-auto max-w-[200px] mx-auto" src={Logo} />
              {hasError && (
                <h3 className="text-[32px] text-center flex justify-center font-secondary-sans uppercase leading-[0.95] flex-grow items-end">
                  Something
                  <br /> went wrong...
                </h3>
              )}
            </div>
            <div className="basis-[40%] text-center flex flex-col justify-end w-full px-6 relative z-[1000] ">
              {showLoader ? (
                <>
                  <Spinner className="mx-auto mb-14" size="lg" />
                </>
              ) : (
                <>
                  {xrStatus === XRCheckStatus.IOS_NO_APP_CLIP && (
                    <div className="flex flex-col items-center">
                      <p className="font-secondary-sans text-2xl leading-[31px] sm:text-2xl text-white mb-12">
                        Your device does not support App Clips
                      </p>
                    </div>
                  )}
                  {isLegacyIOS ? (
                    <>
                      {xrStatus === XRCheckStatus.IOS_NOT_SAFARI && (
                        <>
                          <p className="font-secondary-sans text-2xl leading-[31px] sm:text-2xl text-white mb-12">
                            Copy the link below
                            <br /> into your Safari mobile browser
                            <br /> and turn off private mode.
                          </p>
                          <div className="flex justify-center items-center">
                            <div className="border-2 min-w-[250px] border-white border-opacity-30 py-3 px-4 max-w-xs flex gap-x-2 relative cursor-pointer">
                              <span className="mb-1 flex-grow text-center max-w-[310px] whitespace-nowrap overflow-hidden text-ellipsis w-full">
                                <CopyToClipboardTrigger
                                  text={targetUrl}
                                  color="white"
                                >
                                  COPY LINK
                                </CopyToClipboardTrigger>
                              </span>
                            </div>
                          </div>
                        </>
                      )}

                      {xrStatus === XRCheckStatus.IOS_INCOGNITO && (
                        <>
                          <p className="font-secondary-sans text-2xl leading-[31px] sm:text-2xl text-white mb-12">
                            Copy the link below
                            <br /> into your Safari mobile browser
                            <br /> and turn off private mode.
                          </p>
                          <div className="flex justify-center items-center">
                            <div className="border-2 min-w-[250px] border-white border-opacity-30 py-3 px-4 max-w-xs flex gap-x-2 relative cursor-pointer">
                              <span className="mb-1 flex-grow text-center max-w-[310px] whitespace-nowrap overflow-hidden text-ellipsis w-full">
                                <CopyToClipboardTrigger
                                  text={targetUrl}
                                  color="white"
                                >
                                  COPY LINK
                                </CopyToClipboardTrigger>
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                      {xrStatus === XRCheckStatus.SHOW_APP_CLIP && (
                        <>
                          <p className="font-secondary-sans text-2xl leading-[31px] sm:text-2xl text-white mb-12">
                            This experience uses App Clips <br />
                            on Apple devices.
                          </p>
                          <a
                            className="pointer-events-auto border-2 border-white px-5 py-4 pb-4 max-w-[250px] w-full mx-auto active:bg-white active:text-black transition-colors"
                            href={`https://play.eyejack.xyz/link/?url=${encodedUrl}`}
                          >
                              OPEN IN APP CLIP
                          </a>
                        </>
                      )}
                    </>
                  ) : (
                    (xrStatus === XRCheckStatus.SHOW_APP_CLIP ||
                      xrStatus === XRCheckStatus.IOS_NOT_SAFARI ||
                      xrStatus === XRCheckStatus.IOS_INCOGNITO) && (
                      <>
                        <p className="font-secondary-sans text-2xl leading-[31px] sm:text-2xl text-white mb-12">
                          This experience uses App Clips <br />
                          on Apple devices.
                        </p>
                        <a
                            className="pointer-events-auto border-2 border-white px-5 py-4 pb-4 max-w-[250px] w-full mx-auto active:bg-white active:text-black transition-colors"
                            href={`https://appclip.apple.com/id?p=com.eyejackapp.EyeJack.Clip&link=https://play.eyejack.xyz/link/?url=${encodedUrl}`}
                        >
                          OPEN IN APP CLIP
                        </a>
                      </>
                    )
                  )}

                  {xrStatus === XRCheckStatus.ANDROID_NOT_CHROME && isMobile && (
                    <>
                      <p className="font-secondary-sans text-2xl leading-[31px] sm:text-2xl text-white mb-12">
                        To run this experience copy the link below and paste it
                        in your Chrome browser.
                      </p>
                      <div className="flex justify-center items-center">
                        <div className="border-2 min-w-[250px] border-white py-3 px-4 max-w-xs flex gap-x-2 relative cursor-pointer hover:bg-white hover:text-black transition-colors">
                          <span className="mb-1 flex-grow text-center max-w-[310px] whitespace-nowrap overflow-hidden text-ellipsis w-full">
                            <CopyToClipboardTrigger
                              text={targetUrl}
                              color="white"
                            >
                              COPY LINK
                            </CopyToClipboardTrigger>
                          </span>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
